// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useExerciseSubmission } from '@hooks/mutations/ledger/useSubmission';
import { UserService } from '@daml.js/utility-credential-app-v0/lib/Utility/Credential/App/V0/Service/User';
import { ERR_ACC_CRED_FREE_OFF, SUC_ACC_CRED_FREE_OFF } from '../../../../utils/strings';

export const useAcceptFreeCredentialOffer = () => {
  const { submit } = useExerciseSubmission(
    UserService.UserService_AcceptFreeCredentialOffer,
    SUC_ACC_CRED_FREE_OFF,
    ERR_ACC_CRED_FREE_OFF,
  );
  return submit;
};
